import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import './styles.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { usePlotlyConfig } from '../../hooks/useResponsive';


const Heritage = () => {

    const [data, setData] = useState([]);
    const { getPlotlyConfig, getPlotlyLayout } = usePlotlyConfig();

    useEffect(() => {
        // Substitua pelo link CSV da sua planilha
        const sheetUrl = process.env.REACT_APP_SHEET_1_URL

        fetch(sheetUrl)
            .then((response) => response.text())
            .then((csvText) => {
                const rows = csvText.split('\n').map((row) => row.split(','));
                setData(rows);
            })
            .catch((error) => console.error('Error fetching data:', error));
    }, []);

    if (data.length === 0) {
        return null; // Retorna null em vez de spinner, deixa o skeleton da página principal gerenciar o loading
    }

    // Preparando os dados para o gráfico
    const xValues = data.slice(1).map((row) => row[0]); // Supondo que a coluna 0 contém datas
    const yValues2 = data.slice(1).map((row) => Number(row[3]) || null); // Supondo que a coluna 4 é a segunda variável
    const yValues5 = data.slice(1).map((row) => Number(row[4]) || null); // Supondo que a coluna 5 é a primeira variável

    const xValues10 = ["2024-09-01", "2026-12-01"]
    const yValues10 = [135000, 200000]

    // Obter a data de hoje
    const today = new Date().toISOString().split('T')[0]; // Formato ISO, sem horas

    return (
        <div className='container-fluid vh-100 w-100  justify-content-center align-items-center'>
            <Plot
                config={getPlotlyConfig()}
                data={[
                    {
                        x: xValues,
                        y: yValues2,
                        type: 'scatter', // Gráfico de linha e pontos
                        fill: 'tozeroy',
                        mode: 'lines+markers+text', // Exibir linhas, pontos e texto
                        marker: { color: 'green' },
                        name: 'Patrimônio (R$)',
                        /*                         text: yValues2.map((val, i) => (i % 2 === 0 ? `R$ ${val}` : '')), // Exibe rótulos a cada dois pontos com prefixo "R$" */
                        textposition: 'top center',
                        textfont: {
                            size: 10, // Aumenta o tamanho da fonte dos rótulos
                            color: 'black' // Cor dos rótulos
                        },
                    },
                    {
                        x: xValues,
                        y: yValues5,
                        type: 'scatter', // Gráfico de linha e pontos
                        fill: 'tozeroy',
                        mode: 'lines+markers+text', // Exibir linhas, pontos e texto
                        marker: { color: 'gray' },
                        name: 'Patrimônio líquido (R$)',
                    },
                    {
                        x: xValues10,
                        y: yValues10,
/*                         visible: 'legendonly', // Não exibida por padrão */
                        type: 'scatter', // Gráfico de linha e pontos
                        mode: 'lines', // Exibir linhas, pontos e texto
                        line: {
                            dash: 'dash', // Linha tracejada
                            width: 2, // Espessura da linha
                            color: '#37aa51' // Cor da linha
                        },
                        name: 'Meta 200k 2026 (R$)',
                        textposition: 'top center',
                        textfont: {
                            size: 10, // Aumenta o tamanho da fonte dos rótulos
                            color: 'black' // Cor dos rótulos
                        },
                    }
                ]}

                layout={getPlotlyLayout({
                    width: 1200,
                    height: 500,
                    title: 'Patrimônio ao longo dos anos',
                    showlegend: true,
                    legend: {
                        x: 0,
                        y: 1,
                        traceorder: 'normal',
                        font: {
                            family: 'sans-serif',
                            size: 12,
                            color: '#000'
                        },
                        bgcolor: '#E2E2E2',
                        bordercolor: '#FFFFFF',
                        borderwidth: 2
                    },
                    yaxis: {
                        title: 'Valores (R$)', // Mesma escala para ambos
                        side: 'right',
                        range: [0, 250000]
                    },
                    xaxis: {
                        tickangle: -45,
                        title: 'Ano',
                        range: ['2013-11-01', '2026-12-01'],
                        type: 'date'
                    },
                    shapes: [
                        {
                            type: 'line',
                            x0: today, // Data de hoje no eixo x
                            x1: today, // Mesmo valor para x1 para fazer uma linha vertical
                            y0: 0, // Linha vai de 0 no eixo y
                            y1: 1, // Até o topo do gráfico
                            xref: 'x', // Referência ao eixo x
                            yref: 'paper', // 'paper' vai de 0 a 1 no eixo y
                            line: {
                                color: 'black', // Cor da linha
                                width: 1, // Espessura da linha
                                dash: 'solid', // Linha tracejada
                            },
                        },
                    ],

                    annotations: [
                        {
                            x: today, // Data de hoje
                            y: 0.99, // Posição vertical do balão (topo do gráfico)
                            xref: 'x',
                            yref: 'paper', // yref 'paper' faz o eixo y ir de 0 a 1
                            text: ' Hoje ', // Texto a ser exibido no balão
                            showarrow: true, // Exibe uma seta apontando para a linha
                            arrowhead: 3, // Formato da seta
                            ax: -50, // Deslocamento horizontal da seta (sem deslocamento)
                            ay: 20, // Deslocamento vertical da seta
                            font: {
                                size: 14, // Tamanho da fonte do texto
                                color: 'black', // Cor do texto
                            },
                            bgcolor: 'white', // Cor de fundo do balão
                            bordercolor: 'black', // Cor da borda do balão
                            borderwidth: 0.8, // Espessura da borda
                        },
                    ],
                })}

            />
        </div>
    );
}

export default Heritage;
